// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.base-signup1 {
    max-width: 100%;
    height: auto; /* Allow height to be determined by content */
    background: #FFF;
    display: flex;
    flex-direction: row;
    margin-top: 0;
}

.base-signup1 .left-section {
    width: 100%;
    height: auto; /* Responsive height */
    position: relative;
}

.base-signup1 .right-section {
    width: 30%; /* Example using percentage */
    height: auto;
    flex-shrink: 0;
    background: #458BEA;
    position: relative;
}

.base-signup1 .back {
    width: 61px;
    height: 61px;
    position: absolute;
    left: 49px;
    top: 39px;
}

.base-signup1 .box {
    display: flex; /* Changed to flex for responsive layout */
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
    padding: 88px; /* Adjust as needed */
    box-sizing: border-box;
    position: static; /* Ensure it's within normal flow */
}

.base-signup1 .title {
    display: flex;
    width: 100%; /* Make width responsive */

    flex-direction: column;
    justify-content: center;
    color: var(--greyscale-greyscale-100, #111);
    font-family: Georgia;
    font-size: 46px;
    font-style: normal;
    font-weight: 700;
    line-height: 1.1; /* Adjust line height for better readability */
    word-wrap: break-word; /* Allow long words to break and wrap */
    overflow-wrap: break-word; /* Ensure words break and wrap as needed */
    margin-bottom: 10px; /* Add some space between title and description */
}

.base-signup1 .desc {
    display: flex;
    width: 100%;

    flex-direction: column;
    justify-content: center;
    color: var(--greyscale-greyscale-70, #6D6D6D);
    font-size: 25px;
    font-style: normal;
    font-weight: 300;
    line-height: 1.1; /* Adjust line height for better readability */
    word-wrap: break-word; /* Allow long words to break and wrap */
    overflow-wrap: break-word; /* Ensure words break and wrap as needed */
}

.base-signup1 .un,
.base-signup1 .ea,
.base-signup1 .pw {
    width: 100%; /* Adjust to fill the container */
    height: 56px;
    flex-shrink: 0;
    background: var(--greyscale-greyscale-5, #F8F8F8);
    display: flex;
    align-items: center;
    margin-top: 20px;
    gap: 15px; /* Reduced from 30px to 15px */
    position: relative; /* Add position relative for absolute positioning of the line */
}

.base-signup1 .un::after,
.base-signup1 .ea::after,
.base-signup1 .pw::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #cecece;
}

.base-signup1 .rect,
.base-signup1 .input {
    width: 100%;
    flex-shrink: 0;
}

.base-signup1 .user,
.base-signup1 .email,
.base-signup1 .lock {
    position: relative;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    opacity: 0.3;
    left: 9px; /* Reduced from 18px to 9px */
}

.base-signup1 .text {
    color: var(--greyscale-greyscale-40, #B6B6B6);
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
}

.base-signup1 .input {
    flex-grow: 1;
    border: none;
    background: transparent;
    outline: none;
    font-size: 18px;
    font-weight: 400;
    color: #111;
    padding-left: 5px; /* Added small padding to prevent text touching the icon */
}

.base-signup1 .button-next-div {

    margin: 100px auto 0;


    background-color: #458BEA;
    color: #FFF;
    border-radius: 6px ;

}

.base-signup1 .button-next {

    margin: 100px auto 0;


    background-color: #458BEA;
    color: #FFF;
    border-radius: 6px ;
}

.base-signup1 .right-title {
    position: absolute;
    width: 327px;
    color: var(--Core-colors-Pyxis-White---L1, #FFF);
    font-family: "Fira Sans";
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    top: 128px;
    left: 27px;
}

.base-signup1 .right-box {
    position: relative;
    width: 201px;
    height: 144px;
    flex-shrink: 0;
    top: 232px;
    left: 58px;
}

.base-signup1 .vertrect {
    position: absolute;
    width: 1px;
    height: 115px;
    flex-shrink: 0;
    top: 15px;
    left: 5px;
    background: var(--Background-color-primary, #FFF);
}

.base-signup1 .frame1 {
    position: absolute;
    display: inline-flex;
    align-items: center;
    gap: 16px;
    bottom: 120px;
    width: 201px;
    height: 24px;
}

.base-signup1 .frame2 {
    position: absolute;
    display: inline-flex;
    align-items: center;
    gap: 16px;
    bottom: 56px;
    left: 2px;
    width: 250px;
    height: 24px;
}

.base-signup1 .frame3 {
    position: absolute;
    display: inline-flex;
    align-items: center;
    gap: 16px;
    top: 120px;
    left: 2px;
    width: 290px;
    height: 24px;
}

.base-signup1 .frame1 .c1 {
    width: 11px;
    height: 11px;
    background-color: white;
    border-radius: 50%;
}

.base-signup1 .frame2 .c1 {
    width: 7px;
    height: 7px;
    background-color: white;
    border-radius: 50%;
}

.base-signup1 .frame3 .c1 {
    width: 7px;
    height: 7px;
    background-color: white;
    border-radius: 50%;
}

.base-signup1 .frame1 .t1 {
    color: var(--Core-colors-Pyxis-White---L1, #FFF);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}

.base-signup1 .frame2 .t1 {
    color: var(--Background-color-primary, #FFF);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
}

.base-signup1 .frame3 .t1 {
    color: var(--Background-color-primary, #FFF);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
}

.base-signup1 .frame1 .oval {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    gap: 10px;
    border-radius: 100px;
    border: 1px solid var(--Core-colors-Pyxis-White---L1, #FFF);
    background: var(--Core-colors-Pyxis-White---L1, #FFF);
}

.base-signup1 .frame2 .oval,
.base-signup1 .frame3 .oval {
    display: none;
}

.base-signup1 .frame1 .t2,
.base-signup1 .frame2 .t2,
.base-signup1 .frame3 .t2 {
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
}

.base-signup1 .image {
    position: absolute;
    flex-shrink: 0;
    top: 347px;
    left: 2px;
}

.base-signup1 .right-section .support {
    position: absolute;
    color: var(--Core-colors-Pyxis-White---L1, #FFF);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    text-decoration-line: underline;
    bottom: 91px;
    left: 29px;
}

.error-message {
    color: red;
    margin-top: 10px;
}

@media (max-width: 1220px) {
    .base-signup1 {
        flex-direction: column;
    }

    .base-signup1 .left-section,
    .base-signup1 .right-section {
        width: 100%;
        height: auto;
        margin: 0;
    }

    .base-signup1 .right-section {
        display: none;
    }

    .base-signup1 .box {
        padding: 20px;
        position: static; /* Ensure it's within normal flow */
    }
}

.input-container {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.input-icon {
    position: absolute;
    left: 10px;
    width: 20px;
    height: 20px;
    color: #888;
}

.input {
    padding-left: 40px;
    margin-left: 10px;
    width: calc(100% - 50px);
}
`, "",{"version":3,"sources":["webpack://./src/components/Setup1/style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY,EAAE,6CAA6C;IAC3D,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY,EAAE,sBAAsB;IACpC,kBAAkB;AACtB;;AAEA;IACI,UAAU,EAAE,6BAA6B;IACzC,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa,EAAE,0CAA0C;IACzD,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,aAAa,EAAE,qBAAqB;IACpC,sBAAsB;IACtB,gBAAgB,EAAE,mCAAmC;AACzD;;AAEA;IACI,aAAa;IACb,WAAW,EAAE,0BAA0B;;IAEvC,sBAAsB;IACtB,uBAAuB;IACvB,2CAA2C;IAC3C,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB,EAAE,8CAA8C;IAChE,qBAAqB,EAAE,uCAAuC;IAC9D,yBAAyB,EAAE,0CAA0C;IACrE,mBAAmB,EAAE,iDAAiD;AAC1E;;AAEA;IACI,aAAa;IACb,WAAW;;IAEX,sBAAsB;IACtB,uBAAuB;IACvB,6CAA6C;IAC7C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB,EAAE,8CAA8C;IAChE,qBAAqB,EAAE,uCAAuC;IAC9D,yBAAyB,EAAE,0CAA0C;AACzE;;AAEA;;;IAGI,WAAW,EAAE,iCAAiC;IAC9C,YAAY;IACZ,cAAc;IACd,iDAAiD;IACjD,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS,EAAE,8BAA8B;IACzC,kBAAkB,EAAE,+DAA+D;AACvF;;AAEA;;;IAGI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,WAAW;IACX,cAAc;AAClB;;AAEA;;;IAGI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,SAAS,EAAE,6BAA6B;AAC5C;;AAEA;IACI,6CAA6C;IAC7C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB,EAAE,0DAA0D;AACjF;;AAEA;;IAEI,oBAAoB;;;IAGpB,yBAAyB;IACzB,WAAW;IACX,mBAAmB;;AAEvB;;AAEA;;IAEI,oBAAoB;;;IAGpB,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gDAAgD;IAChD,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,cAAc;IACd,SAAS;IACT,SAAS;IACT,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,SAAS;IACT,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gDAAgD;IAChD,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,oBAAoB;IACpB,2DAA2D;IAC3D,qDAAqD;AACzD;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;;IAGI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gDAAgD;IAChD,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,gBAAgB,EAAE,mCAAmC;IACzD;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;AAC5B","sourcesContent":[".base-signup1 {\n    max-width: 100%;\n    height: auto; /* Allow height to be determined by content */\n    background: #FFF;\n    display: flex;\n    flex-direction: row;\n    margin-top: 0;\n}\n\n.base-signup1 .left-section {\n    width: 100%;\n    height: auto; /* Responsive height */\n    position: relative;\n}\n\n.base-signup1 .right-section {\n    width: 30%; /* Example using percentage */\n    height: auto;\n    flex-shrink: 0;\n    background: #458BEA;\n    position: relative;\n}\n\n.base-signup1 .back {\n    width: 61px;\n    height: 61px;\n    position: absolute;\n    left: 49px;\n    top: 39px;\n}\n\n.base-signup1 .box {\n    display: flex; /* Changed to flex for responsive layout */\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n    width: 100%;\n    padding: 88px; /* Adjust as needed */\n    box-sizing: border-box;\n    position: static; /* Ensure it's within normal flow */\n}\n\n.base-signup1 .title {\n    display: flex;\n    width: 100%; /* Make width responsive */\n\n    flex-direction: column;\n    justify-content: center;\n    color: var(--greyscale-greyscale-100, #111);\n    font-family: Georgia;\n    font-size: 46px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 1.1; /* Adjust line height for better readability */\n    word-wrap: break-word; /* Allow long words to break and wrap */\n    overflow-wrap: break-word; /* Ensure words break and wrap as needed */\n    margin-bottom: 10px; /* Add some space between title and description */\n}\n\n.base-signup1 .desc {\n    display: flex;\n    width: 100%;\n\n    flex-direction: column;\n    justify-content: center;\n    color: var(--greyscale-greyscale-70, #6D6D6D);\n    font-size: 25px;\n    font-style: normal;\n    font-weight: 300;\n    line-height: 1.1; /* Adjust line height for better readability */\n    word-wrap: break-word; /* Allow long words to break and wrap */\n    overflow-wrap: break-word; /* Ensure words break and wrap as needed */\n}\n\n.base-signup1 .un,\n.base-signup1 .ea,\n.base-signup1 .pw {\n    width: 100%; /* Adjust to fill the container */\n    height: 56px;\n    flex-shrink: 0;\n    background: var(--greyscale-greyscale-5, #F8F8F8);\n    display: flex;\n    align-items: center;\n    margin-top: 20px;\n    gap: 15px; /* Reduced from 30px to 15px */\n    position: relative; /* Add position relative for absolute positioning of the line */\n}\n\n.base-signup1 .un::after,\n.base-signup1 .ea::after,\n.base-signup1 .pw::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background-color: #cecece;\n}\n\n.base-signup1 .rect,\n.base-signup1 .input {\n    width: 100%;\n    flex-shrink: 0;\n}\n\n.base-signup1 .user,\n.base-signup1 .email,\n.base-signup1 .lock {\n    position: relative;\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n    opacity: 0.3;\n    left: 9px; /* Reduced from 18px to 9px */\n}\n\n.base-signup1 .text {\n    color: var(--greyscale-greyscale-40, #B6B6B6);\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px;\n}\n\n.base-signup1 .input {\n    flex-grow: 1;\n    border: none;\n    background: transparent;\n    outline: none;\n    font-size: 18px;\n    font-weight: 400;\n    color: #111;\n    padding-left: 5px; /* Added small padding to prevent text touching the icon */\n}\n\n.base-signup1 .button-next-div {\n\n    margin: 100px auto 0;\n\n\n    background-color: #458BEA;\n    color: #FFF;\n    border-radius: 6px ;\n\n}\n\n.base-signup1 .button-next {\n\n    margin: 100px auto 0;\n\n\n    background-color: #458BEA;\n    color: #FFF;\n    border-radius: 6px ;\n}\n\n.base-signup1 .right-title {\n    position: absolute;\n    width: 327px;\n    color: var(--Core-colors-Pyxis-White---L1, #FFF);\n    font-family: \"Fira Sans\";\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 32px;\n    top: 128px;\n    left: 27px;\n}\n\n.base-signup1 .right-box {\n    position: relative;\n    width: 201px;\n    height: 144px;\n    flex-shrink: 0;\n    top: 232px;\n    left: 58px;\n}\n\n.base-signup1 .vertrect {\n    position: absolute;\n    width: 1px;\n    height: 115px;\n    flex-shrink: 0;\n    top: 15px;\n    left: 5px;\n    background: var(--Background-color-primary, #FFF);\n}\n\n.base-signup1 .frame1 {\n    position: absolute;\n    display: inline-flex;\n    align-items: center;\n    gap: 16px;\n    bottom: 120px;\n    width: 201px;\n    height: 24px;\n}\n\n.base-signup1 .frame2 {\n    position: absolute;\n    display: inline-flex;\n    align-items: center;\n    gap: 16px;\n    bottom: 56px;\n    left: 2px;\n    width: 250px;\n    height: 24px;\n}\n\n.base-signup1 .frame3 {\n    position: absolute;\n    display: inline-flex;\n    align-items: center;\n    gap: 16px;\n    top: 120px;\n    left: 2px;\n    width: 290px;\n    height: 24px;\n}\n\n.base-signup1 .frame1 .c1 {\n    width: 11px;\n    height: 11px;\n    background-color: white;\n    border-radius: 50%;\n}\n\n.base-signup1 .frame2 .c1 {\n    width: 7px;\n    height: 7px;\n    background-color: white;\n    border-radius: 50%;\n}\n\n.base-signup1 .frame3 .c1 {\n    width: 7px;\n    height: 7px;\n    background-color: white;\n    border-radius: 50%;\n}\n\n.base-signup1 .frame1 .t1 {\n    color: var(--Core-colors-Pyxis-White---L1, #FFF);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n\n.base-signup1 .frame2 .t1 {\n    color: var(--Background-color-primary, #FFF);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n}\n\n.base-signup1 .frame3 .t1 {\n    color: var(--Background-color-primary, #FFF);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n}\n\n.base-signup1 .frame1 .oval {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 4px 8px;\n    gap: 10px;\n    border-radius: 100px;\n    border: 1px solid var(--Core-colors-Pyxis-White---L1, #FFF);\n    background: var(--Core-colors-Pyxis-White---L1, #FFF);\n}\n\n.base-signup1 .frame2 .oval,\n.base-signup1 .frame3 .oval {\n    display: none;\n}\n\n.base-signup1 .frame1 .t2,\n.base-signup1 .frame2 .t2,\n.base-signup1 .frame3 .t2 {\n    color: #000;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 16px;\n}\n\n.base-signup1 .image {\n    position: absolute;\n    flex-shrink: 0;\n    top: 347px;\n    left: 2px;\n}\n\n.base-signup1 .right-section .support {\n    position: absolute;\n    color: var(--Core-colors-Pyxis-White---L1, #FFF);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    text-decoration-line: underline;\n    bottom: 91px;\n    left: 29px;\n}\n\n.error-message {\n    color: red;\n    margin-top: 10px;\n}\n\n@media (max-width: 1220px) {\n    .base-signup1 {\n        flex-direction: column;\n    }\n\n    .base-signup1 .left-section,\n    .base-signup1 .right-section {\n        width: 100%;\n        height: auto;\n        margin: 0;\n    }\n\n    .base-signup1 .right-section {\n        display: none;\n    }\n\n    .base-signup1 .box {\n        padding: 20px;\n        position: static; /* Ensure it's within normal flow */\n    }\n}\n\n.input-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.input-icon {\n    position: absolute;\n    left: 10px;\n    width: 20px;\n    height: 20px;\n    color: #888;\n}\n\n.input {\n    padding-left: 40px;\n    margin-left: 10px;\n    width: calc(100% - 50px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
